export default function FormatPrice (price = 0) {
  return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN"
  }).format(price);
}